import api from '@/apis/di/budgetChapterAPI';
// import Crud from '@/stores/crudBase';
import CrudCache from '@/stores/crudBaseCache.js';
var crud = new CrudCache('budgetChapter', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_budget_chapter',
    field: {
      key: 'budget_chapter_id',
      code: 'budget_chapter_code',
      name: 'budget_chapter_name',
      quickFollow: 'active', // NTLoc-2022/05/06 : thêm key để update trạng thái theo dõi
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
